import React from 'react';
export function Footer() {
  return <footer className="bg-background py-8 border-t border-border" data-id="element-70">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-71">
        <div className="text-xl font-semibold tracking-tight text-primary" data-id="element-72">
          Прописка.Київ
        </div>

        <div className="flex gap-6 text-sm text-secondary" data-id="element-73">
          <a href="#" className="hover:text-primary transition-colors" data-id="element-74">
            Telegram
          </a>
          <a href="#" className="hover:text-primary transition-colors" data-id="element-75">
            Viber
          </a>
          <a href="#" className="hover:text-primary transition-colors" data-id="element-76">
            Facebook
          </a>
        </div>

        <div className="text-sm text-secondary" data-id="element-77">
          &copy; {new Date().getFullYear()} Всі права захищені.
        </div>
      </div>
    </footer>;
}